import { useEffect, useState } from "react";
import api, { apiError, fmtDate } from "@/lib/api";
import { toast } from "sonner";
import { Trash2, RotateCcw } from "lucide-react";
import { EliminaDefBtn, SvuotaCestinoBtn } from "@/components/CestinoDefinitivo";
import { BarraElenco, Casella, SelezionaTutto, azioniCestino, useSelezione } from "@/components/SelezioneFile";

export function ProposteCestino({ onRestored }) {
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(false);
  const S = useSelezione();
  const load = () => api.get("/cestino/proposte").then((r) => setList(r.data)).catch(() => setList([]));
  useEffect(() => { load(); }, []);
  const ripristina = async (c) => {
    try { await api.post(`/admin/pulizia-dati/cestino/${c.id}/ripristina`); toast.success("Proposta ripristinata"); load(); onRestored?.(); }
    catch (e) { toast.error(apiError(e)); }
  };
  return (
    <div className="mt-6" data-testid="proposte-cestino">
      <button data-testid="proposte-box-cestino" aria-expanded={open} onClick={() => setOpen((o) => !o)}
        className={`rounded-2xl border-2 p-4 text-left min-w-[200px] bg-red-50 border-red-200 text-red-700 transition-transform hover:-translate-y-0.5 ${open ? "ring-2 ring-red-400" : ""}`}>
        <div className="flex items-center gap-2 text-sm font-bold"><Trash2 size={16} /> Cestino</div>
        <div className="mono text-3xl font-extrabold mt-1 text-[#111111]" data-testid="proposte-cestino-count">{list.length}</div>
      </button>
      {open && (
        <div className="mt-3">
          <div className="flex items-center justify-between mb-2"><SelezionaTutto ids={list.map((c) => c.id)} sel={S.sel} onTutti={S.tutti} testid="proposte-cestino-seltutto" /><SvuotaCestinoBtn ambito="proposte" count={list.length} onDone={load} /></div>
          <BarraElenco sel={S.sel} onAnnulla={S.annulla} onFatto={() => { load(); onRestored?.(); }}
            azioni={azioniCestino((id) => api.post(`/admin/pulizia-dati/cestino/${id}/ripristina`), (id) => api.post(`/cestino/proposte/${id}/elimina-definitivo`, { conferma: "ELIMINA" }))} />
          <div className="card-immo p-0 divide-y divide-[var(--border)]" data-testid="proposte-cestino-list">
            {list.length === 0 ? <div className="p-5 text-sm text-[var(--muted)]">Nessuna proposta nel Cestino.</div> : list.map((c) => (
              <div key={c.id} className={`p-4 flex items-center gap-3 flex-wrap ${S.sel.has(c.id) ? "bg-[#FC82ED]/10" : ""}`} data-testid={`proposta-cestino-${c.orig_id}`}>
                <Casella inline on={S.sel.has(c.id)} onToggle={() => S.toggle(c.id)} testid={`proposta-cestino-sel-${c.orig_id}`} />
                <div className="flex-1 min-w-[200px]">
                  <div className="font-semibold text-sm">{c.titolo || "Proposta"}</div>
                  <div className="text-[11px] text-[var(--muted)]">Eliminata il {fmtDate(c.cestino?.at)} da {c.cestino?.by || "—"} · cancellazione definitiva il {fmtDate(c.cestino?.scade_il)}</div>
                </div>
                <button data-testid={`proposta-ripristina-${c.orig_id}`} onClick={() => ripristina(c)}
                  className="inline-flex items-center gap-1.5 px-3 py-2 rounded-xl bg-[#111111] text-white text-xs font-semibold"><RotateCcw size={14} /> Ripristina</button>
                <EliminaDefBtn ambito="proposte" id={c.id} onDone={load} testid={`proposta-elimina-def-${c.orig_id}`} />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
